import styles from 'styles/components/common/lists/DualHeaderTable.module.scss';
import { TEvaluationChartCountInfo } from 'types/apis/professor';

type TProps = {
  width?: string;
  colHeight?: string;
  dataHeight?: string;
  fontSize?: string;
  studentCount?: number;
  finishCount: TEvaluationChartCountInfo[];
};

const DualHeaderTable = ({
  width,
  colHeight,
  dataHeight,
  fontSize,
  studentCount,
  finishCount,
}: TProps) => {
  return (
    <div className="dual_table">
      <table>
        <thead>
          <tr className={styles.tr}>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              전신병력
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              치과병력
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구강위생관리
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              생징후
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.tr}>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '전신병력'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '치과병력'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구강위생관리'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '생징후'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <thead>
          <tr className={styles.tr}>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구강 외·내 검사
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              치아검사
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구내미생물검사
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구내예방처치
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.tr}>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구강 외·내 검사'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '치아검사'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구내미생물검사'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구내예방처치'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default DualHeaderTable;
